(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const quantityControls = document.querySelectorAll('.cart-quantity');
  
  quantityControls.forEach(control => {
    const minusBtn = control.querySelector('.qty-minus');
    const plusBtn = control.querySelector('.qty-plus');
    const input = control.querySelector('.quantity-input');
    const itemKey = control.dataset.cartItemKey;

    minusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      let currentValue = parseInt(input.value) || 0;
      if (currentValue > 0) {
        input.value = currentValue - 1;
        updateCartItem(itemKey, currentValue - 1);
      }
    });

    plusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      let currentValue = parseInt(input.value) || 0;
      input.value = currentValue + 1;
      updateCartItem(itemKey, currentValue + 1);
    });

    input.addEventListener('change', function() {
      let value = parseInt(this.value) || 0;
      updateCartItem(itemKey, value);
    });
  });

  function updateCartItem(itemKey, newQuantity) {
    const formData = new FormData();
    formData.append('id', itemKey);
    formData.append('quantity', newQuantity);

    fetch('/cart/change.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      location.reload(); // Refresh to update all totals accurately
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      location.reload();
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
